<template>
  <span>
    <v-progress-circular
      indeterminate
      color="indigo darken-1"
      size="80"
      class="cargando"
      v-show="cargandoRegistro"
    ></v-progress-circular>

    <!-- {{definicionCampos}} -->
    <!-- {{cabeceras}} -->
    <!-- {{registros}} -->
    <!-- {{registrosSeleccionados}} -->

    <v-data-table
      :headers="cabeceras"
      :items="registrosNoBorrados"
      :options.sync="opcionesTabla"
      :server-items-length="totalRegistrosSinPaginar"
      :loading="cargando"
      :class="classDataTable"
      :footer-props="{'items-per-page-options': opcionesFilasPorPagina() }"
      :disable-filtering="modoMemoria"
      :disable-sort="modoMemoria || deshabilitarOrdenar"
      :hide-default-footer="modoMemoria || ocultarPie"
      :style="estiloCSS"
      :dense="vistaCompacta"
      @dblclick:row="dobleClickFila"
      @click:row="clickFila"
      v-bind="$attrs"
      v-model="registrosSeleccionados"
    >
      <!-- titulo -->
      <template v-if="titulo != null" v-slot:top>
        <v-container fluid>
          <v-row style="background-color: #b0b0c0; padding-right: 14px">
            <v-col style="padding: 10px 8px 8px 14px; white-space: nowrap;">
              <span style="font-size: 15pt">
                <v-icon v-if="icono" class="mt-n1 mr-1" @click="mostrarOcultarOpcionesFiltrado">{{icono}}</v-icon>
                {{titulo}}
                <v-btn
                  small
                  rounded
                  color="primary"
                  v-if="permitirAnadir"
                  dark
                  class="ml-3 mr-2 mt-n2"
                  @click="anadirRegistro(null)"
                >
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
                <slot name="derecha-titulo" />
              </span>
            </v-col>
            <v-col v-if="busquedaRapida && !modoMemoria" style="padding: 7px 8px 8px 18px; min-width: 200px">
              <v-text-field
                v-model="cadenaABuscar"
                @keyup="iniciarTemporizadorBusqueda"
                @click:clear="iniciarTemporizadorBusqueda"
                append-icon="mdi-magnify"
                :label="$t ('Buscar')"
                dense
                single-line
                hide-details
                clearable
                :background-color="cadenaABuscar ? '#FFF59D' : ''"
              ></v-text-field>
            </v-col>
            <v-col v-if="camposFiltrables" cols="auto" style="padding: 7px 0px 8px 7px">
              <v-btn
                small
                :color="opcionesFiltradoVisible ? '#dcdcd0' : ''"
                :text="!opcionesFiltradoVisible"
                :elevation="0"
                :outlined="!opcionesFiltradoVisible"
                class="mt-1 px-1"
                style="min-width: 30px"
                @click="mostrarOcultarOpcionesFiltrado"
              >
                <v-icon small>mdi-filter</v-icon>
              </v-btn>
            </v-col>
            <v-col v-if="camposInterno.length > 0" cols="auto" style="padding: 7px 0px 8px 7px">
              <BotonColumnasTablaDatosAPI
                :id-tabla-vista="tabla"
                :definicion-campos="definicionCampos"
                :campos="camposInterno"
                @cambios="prepararCabeceras"
              />
            </v-col>
            <v-col cols="auto" style="padding: 7px 0px 8px 7px">
              <BotonDescargaTablaDatosAPI
                :tabla-datos-api="instanciaTablaDatosAPI"
              />
            </v-col>
            <v-col cols="auto" style="padding: 7px 0px 8px 7px">
              <BotonOpcionesTablaDatosAPI
                :tabla-datos-api="instanciaTablaDatosAPI"
              />
            </v-col>
          </v-row>
        </v-container>

        <slot name="debajo-titulo" />

        <div class="px-4 py-3" v-if="camposFiltrables && opcionesFiltradoVisible" style="background-color: #dcdcd0">
          <PanelCamposFiltrables
            :campos-filtrables="camposFiltrables"
            :definicion-campos="definicionCampos"
            @cambios="actualizarOpcionesFiltrado"
          />
        </div>
      </template>

      <!-- pasamos los slots especificados en TablaDatosAPI -->
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope"><slot :name="slot" v-bind="scope"/></template>

      <!-- botones de accion de registros -->
      <template v-slot:[`item.__acciones`]="{ item }">
        <slot name="accionesPersonalizadas" v-bind:item="item"></slot>
        <v-icon v-if="permitirModificar" small color="primary" class="mr-2" @click="editarRegistro (item)">mdi-pencil</v-icon>
        <v-icon v-if="permitirEliminar" small color="primary" @click="eliminarRegistro (item)">mdi-delete</v-icon> <!-- color="#E06060" -->
      </template>

      <!-- boton de añadir en modo compacto o para cuando "modoMemoria = true" -->
      <template v-if="(!titulo && permitirAnadir) || modoMemoria" v-slot:footer>
        <v-divider />
        <v-row no-gutters>
          <v-spacer />
          <v-btn v-if="!titulo && permitirAnadir"
            :small="$attrs.dense"
            rounded
            color="#8080FF"
            dark
            text
            class="my-1"
            @click="anadirRegistro(null)"
          >
            <v-icon small class="mr-1">mdi-plus</v-icon>{{ $t ('Añadir') }}
          </v-btn>
          <v-spacer />
          <div v-if="modoMemoria" class="text-caption pa-2 mr-5">
              {{ $t ('Total filas') }}: {{registrosNoBorrados.length}}
          </div>
        </v-row>
      </template>

    </v-data-table>

    <FormularioDatosAPI
      ref="formulario"
      :icono="icono"
      v-bind="formularioDatosApiProps"
      @campo-formulario-datos-montado="campoFormularioDatosMontado"
      :alto-minimo="altoMinimoVentana"
    >
      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <slot :definicionCampos="definicionCampos" :datosRegistro="datosRegistro" :accionCrud="accionCrud" :esAccionEliminar="esAccionEliminar"></slot>
      </template>
    </FormularioDatosAPI>
  </span>
</template>

<script>
import { DateTime } from "luxon";
import api from "@/api";
import FormularioDatosAPI from "@/components/FormularioDatosAPI.vue";
import PanelCamposFiltrables from "@/components/PanelCamposFiltrables.vue";
import BotonColumnasTablaDatosAPI from "@/components/BotonColumnasTablaDatosAPI.vue";
import BotonDescargaTablaDatosAPI from "@/components/BotonDescargaTablaDatosAPI.vue";
import BotonOpcionesTablaDatosAPI from "@/components/BotonOpcionesTablaDatosAPI.vue";
import CONSTANTES_CRUD from "@/constantesCRUD"

export default {
  components: {
    FormularioDatosAPI,
    PanelCamposFiltrables,
    BotonColumnasTablaDatosAPI,
    BotonDescargaTablaDatosAPI,
    BotonOpcionesTablaDatosAPI
  },
  props: {
    tabla: {
      type: String,
      required: true
    },
    campos: {
      type: Array,
      required: true
    },
    titulo: {
      type: String,
      default: null,
    },
    icono: {
      type: String,
      default: null
    },
    camposFiltrables: Array,
    parametros: Object,
    objetoDefinicionCampos: Object,
    objetoRegistroFormulario: Object,
    sinSombra: Boolean,
    busquedaRapida: Boolean,
    permitirAnadir: Boolean,
    permitirModificar: Boolean,
    permitirEliminar: Boolean,
    accionesPersonalizadas: Boolean,
    mensajeConfirmacionAlEliminar: String,
    tituloCrud: {
      type: String,
      default: "registro",
    },
    zoom: {
      type: Number,
      default: 1.0,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    campoSujetoAccion: String,
    altoMinimoVentana: {
      typer: String,
      default: "0",
    },
    filasPorPagina: {
      type: Number,
      default: 10,
    },
    modoMemoria: {
      type: Boolean,
      default: false,
    },
    segundosAutoRefresco: {
      type: Number,
      default: 0,
    },
    ocultarPie: {
      type: Boolean,
      default: false,
    },
    deshabilitarOrdenar: Boolean,
    ocultarRejilla: Boolean,
    formularioDatosApiProps: Object,
    eventoAntesProcesarRespuestaServidor: Function,
    eventoAntesAbrirFormularioDatos: Function,
    eventoAntesGuardarFormularioDatos: Function, // debe ser un a funcion "aync" para poder abortar el guardado si así se necesitara (devolviendo "false")
    eventoDespuesGuardarFormularioDatos: Function,
    eventoDobleClickFila: Function,
    eventoErrorApi: Function,
  },
  data() {
    this.idIntervalo = null;
    return {
      instanciaTablaDatosAPI: null,
      camposInterno: [],
      opcionesTabla: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      cadenaABuscar: null,
      ultimaCadenaABuscar: null,
      temporizadorBusqueda: null,
      cabeceras: [],
      registros: [],
      definicionCampos: {},
      cargando: false,
      cargandoRegistro: false,
      totalRegistrosSinPaginar: 0,
      registrosSeleccionados: [],
      formulario: null,
      opcionesFiltradoVisible: false,
      filtros: {},
      valorZoom: 1,
      vistaCompacta: false,

      definicionCamposFormulario: {},
      datosRegistroFormulario: {},
    };
  },
  computed: {
    classDataTable () {
      if (!this.sinSombra)
        return "elevation-4";
      else
        return "";
    },
    registrosNoBorrados () {
      return this.registros.filter (registro => registro ['!!'] != CONSTANTES_CRUD.ACCION.DELETE );
    },
    estiloCSS () {
      return {
        zoom: this.valorZoom
      };
    },
  },
  methods: {
    campoFormularioDatosMontado(campoFormularioDatos) {
      this.$emit ('campo-formulario-datos-montado', campoFormularioDatos)
    },
    opcionesFilasPorPagina() {
      if (this.filasPorPagina == -1)
        return [-1]
      else
        return [5, 10, 15, 20, 25, 50, 100, 250, 500];
    },
    iniciarTemporizadorBusqueda() {
      if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
      this.temporizadorBusqueda = setTimeout(this.comprobarCambiosEnTextoBusqueda, 500);
    },
    limpiarSeleccion() {
      if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {  // IE?
        document.selection.empty();
      }
    },
    clickFila (item, row) {
      if (this.$attrs['item-key'])
        row.select(!row.isSelected);
    },
    dobleClickFila (mouseEvent, datos) {
      this.limpiarSeleccion();

      if (this.eventoDobleClickFila)
        this.eventoDobleClickFila (datos.item);
      else if (this.permitirModificar)
        this.editarRegistro (datos.item);
    },
    opcionesConsultaTablaVista() {
      let opciones = {};
      let camposOrden = [];
      let descripcionOrden = [];

      if (Object.keys (this.definicionCampos).length > 0)
        opciones.dc = 1;

      if (!this.modoMemoria && this.filasPorPagina > 0) {
        // calculamos el registro inicial (_offset) dado el nº de pagina y nº de registros por pagina
        opciones.offset = (this.opcionesTabla.page - 1) * this.opcionesTabla.itemsPerPage;
        // indicamos el nº de registros por pagina
        opciones.limit = this.opcionesTabla.itemsPerPage;
        // indicamos la cadena de búsqueda rapida
        if (this.cadenaABuscar) {
          opciones.busqueda = {
            valor: this.cadenaABuscar,
            descripcion: this.$t ('Búsqueda') + ': "' + this.cadenaABuscar + '"'
          };
        }
        // establecemos el orden de la consulta de acuerdo con "opcionesTabla.sortBy" y "opcionesTabla.sortDesc"
        this.opcionesTabla.sortBy.forEach((campo, indiceCampo) => {
          let nombreCampo = campo.replace ("__VT", "");
          if (this.opcionesTabla.sortDesc[indiceCampo]) {
            camposOrden.push (nombreCampo + " DESC");
            descripcionOrden.push (this.definicionCampos [nombreCampo].titulo + " (desc.)");
          } else {
            camposOrden.push (nombreCampo);
            descripcionOrden.push (this.definicionCampos [nombreCampo].titulo);
          }
        });
        // indicamos el orden especificado de los registros
        if (camposOrden.length > 0) {
          opciones.orden = {
            valor: camposOrden.join (', '),
            descripcion: this.$t ('Orden: ') + descripcionOrden.join (', ')
          };
        }
      }
      // volcamos los parametros de la consulta
      opciones.parametros = this.parametros ?? {};
      // añadimos los filtros a las opciones
      opciones.filtros = this.filtros;

      //console.log (JSON.stringify (opciones, null, 2));
      return opciones;
    },
    claveRegistro (registro) {
      let clave = {};
      for (const nombreCampo in this.definicionCampos) {
        const campo = this.definicionCampos[nombreCampo];
        if (campo.es_clave == true && registro [nombreCampo] != undefined)
          clave [nombreCampo] = JSON.stringify (registro [nombreCampo]);
      }
      if (Object.keys (clave).length > 0)
        return clave;
      else
        return null;
    },
    hayCambiosModoMemoria () {
      return this.registros.some ((registro) => (registro ['!!'] != undefined));
    },
    loteCambiosRegistros (callback){
      let lote = { insertar: [], actualizar: [], eliminar: [] };
      this.registros.forEach((registro) => {
        let copiaRegistro = JSON.parse (JSON.stringify (registro));
        if (callback)
          callback (copiaRegistro);
        Object.keys (copiaRegistro).forEach ((campo) => {
          if (campo == "!!" || campo.toUpperCase().includes ("__VT"))
            delete copiaRegistro [campo];
        });
        if (registro ['!!'] == 'C')
          lote.insertar.push (copiaRegistro);
        else if (registro ['!!'] == 'U')
          lote.actualizar.push (copiaRegistro);
        else if (registro ['!!'] == 'D')
          lote.eliminar.push (copiaRegistro);
      });
      lote.cambios = (lote.insertar.length > 0) || (lote.actualizar.length > 0) || (lote.eliminar.length > 0);
      return lote;
    },
    complementarDatos (arrayRegistros) {
      // aplicamos dominios de valores (reemplazamos valores por sus correspondientes descripciones)
      // sobre el array de filas obtenido de la consulta
      for (const nombreCampo in this.definicionCampos) {
        const dc = this.definicionCampos [nombreCampo];
        let nombreCampoVT = nombreCampo; // nombre del campo que contendrá el "Valor Transformado"

        if (dc.seleccion_multiple && dc.dominio_valores) {
          nombreCampoVT += "__VT";
          arrayRegistros.forEach((registro) => {
            if (dc.control != "lista-valores") {
              let aux = "";
              if (Array.isArray (registro [nombreCampo])) {
                registro [nombreCampo].forEach ((valor) => {
                  if (aux != "") aux += ", ";
                  let descripcionValor = dc.dominio_valores[JSON.stringify (valor)];
                  if (descripcionValor == undefined)
                    descripcionValor = `¿${valor}?`;
                  aux += descripcionValor;
                });
              }
              this.$set (registro, nombreCampoVT, aux);
            }
          });
        } else if (dc.dominio_valores) {
          nombreCampoVT += "__VT";
          arrayRegistros.forEach((registro) => {
            this.$set (registro, nombreCampoVT, dc.dominio_valores[JSON.stringify (registro [nombreCampo] !== undefined ? registro [nombreCampo] : null)]);
            /*if (registro [nombreCampo] !== undefined) {
              let descripcion_dominio = dc.dominio_valores [JSON.stringify (registro [nombreCampo])];
              if (descripcion_dominio == undefined)
                descripcion_dominio = ''; //descripcion_dominio = '¿' + registro [nombreCampo] + '?';
              this.$set (registro, nombreCampoVT, descripcion_dominio);
            } else
              this.$set (registro, nombreCampoVT, null); */
          });
        } else if (dc.tipo && dc.tipo.toUpperCase().includes("DATETIME")) {
          nombreCampoVT += "__VT";
          arrayRegistros.forEach((registro) => {
            if (registro [nombreCampo] && dc.formato)
              this.$set (registro, nombreCampoVT, DateTime.fromSQL(registro [nombreCampo]).setLocale('es').toFormat(dc.formato));
            else if (registro [nombreCampo])
              this.$set (registro, nombreCampoVT, DateTime.fromSQL(registro [nombreCampo]).setLocale('es').toFormat("dd-MM-yyyy HH:mm"));
            else
              this.$set (registro, nombreCampoVT, '-');
          });
        } else if (dc.prefijo_valor || dc.sufijo_valor) {
          nombreCampoVT += "__VT";
          arrayRegistros.forEach((registro) => {
            if (registro [nombreCampo] != null)
              this.$set (registro, nombreCampoVT, (dc.prefijo_valor ?? '') + registro [nombreCampo] + (dc.sufijo_valor ?? ''));
            else
              this.$set (registro, nombreCampoVT, '');
          });
        }
        this.definicionCampos [nombreCampo].nombreCampoVT = nombreCampoVT;
      }
    },
    prepararCabeceras() {
      // creamos/actualizamos el array de opciones de cabecera de tabla segun la configuracion obtenida de la consulta
      this.cabeceras = [];
      this.camposInterno.forEach ((nombreCampo) => {
        let obligatorio = nombreCampo.endsWith ('+');
        let oculto = nombreCampo.endsWith ('-');
        if (obligatorio || oculto)
          nombreCampo = nombreCampo.slice (0, -1);

        if (oculto) return;

        const dc = this.definicionCampos[nombreCampo];
        if (!dc || dc.visibilidad == '-') return;

        let cabecera = {};
        cabecera.value = dc.nombreCampoVT;
        cabecera.text = dc.titulo;
        if (dc.alineacion != null) {
          if (dc.alineacion.toUpperCase().charAt(0) == "C")
            cabecera.align = "center";
          else if (dc.alineacion.toUpperCase().charAt(0) == "D")
            cabecera.align = "end";
        }
        if (dc.clase_estilo)
          cabecera.cellClass = dc.clase_estilo;
        if (dc.ancho_columna_tabla)
          cabecera.width = dc.ancho_columna_tabla;
        if (nombreCampo.substr(0, 2) == "__")
          cabecera.sortable = false;
        this.cabeceras.push(cabecera);
      });

      // si se ha indicado, añadimos un a columna adicional para las acciones (modificar, eliminar)
      if (this.cabeceras.length > 0 && this.totalRegistrosSinPaginar > 0 && (this.permitirModificar || this.permitirEliminar || this.accionesPersonalizadas)) {
        this.cabeceras.push({
          text: this.$t ("Acciones"),
          value: "__acciones",
          align: "center",
          sortable: false,
        });
      }
      //console.log (JSON.stringify (this.cabeceras));
    },
    actualizarDatos() {
      this.cargando = (this.segundosAutoRefresco == 0); //mostramos la barra de progreso solo si no se trata de un "autorefresco"
      api.obtenerRegistrosTablaVista (
          this.tabla,
          { _ooc: JSON.stringify (this.opcionesConsultaTablaVista()) } // parametro "_ooc" = objeto opciones de consulta serializado como JSON
        )
        .then ((respuesta) => {
          if (this.eventoAntesProcesarRespuestaServidor)
            this.eventoAntesProcesarRespuestaServidor (respuesta.data.definicionCampos, respuesta.data.filas, respuesta.data.totalRegistrosSinPaginar);

          if (respuesta.data.definicionCampos) {
            for (const clave in this.definicionCampos)
              this.$delete (this.definicionCampos, clave);
            Object.entries (respuesta.data.definicionCampos).forEach (([clave, valor]) => {
              this.$set (this.definicionCampos, clave, valor);
            });
          }
          this.registros = respuesta.data.filas; // volcamos la respuesta de la consulta a la variable reactiva del componente
          this.totalRegistrosSinPaginar = respuesta.data.totalFilasDisponibles;

          this.complementarDatos (this.registros);

          if (this.camposInterno.length == 1 && this.camposInterno [0] == '*')
            this.camposInterno = Object.keys (this.definicionCampos);

          this.prepararCabeceras ();

          this.$emit ("datos-actualizados", this.definicionCampos, this.registros, this.totalRegistrosSinPaginar);
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    actualizarOpcionesFiltrado (objetoFiltros) {
      this.filtros = objetoFiltros;
      this.actualizarDatosPorCambiosEnBusqueda();
    },
    mostrarOcultarOpcionesFiltrado (){
      this.opcionesFiltradoVisible = !this.opcionesFiltradoVisible;
      if (!this.opcionesFiltradoVisible)
        this.actualizarOpcionesFiltrado ({});
    },
    comprobarCambiosEnTextoBusqueda() {
      if (this.cadenaABuscar != this.ultimaCadenaABuscar) {
        this.ultimaCadenaABuscar = this.cadenaABuscar;
        this.actualizarDatosPorCambiosEnBusqueda();
      }
    },
    actualizarDatosPorCambiosEnBusqueda() {
      this.opcionesTabla.page = 1; // importante forzar la pagina 1 cada vez que cambiamos las opciones de busqueda
      this.actualizarDatos();
    },
    antesCerrarFormularioDatos(formularioDatos, cancelado) {
      if (!cancelado && !this.modoMemoria)
        this.actualizarDatos();
      return true;
    },
    actualizarDatosSiFormularioNoVisible(){
      if (!this.formulario.visible)
        this.actualizarDatos();
    },
    copiarDefinicionCamposADefinicionCamposFormulario() {
      for (const clave in this.definicionCamposFormulario)
        this.$delete (this.definicionCamposFormulario, clave);
      Object.entries (this.definicionCampos).forEach (([clave, valor]) => {
        if (valor !== undefined)
          this.$set (this.definicionCamposFormulario, clave, JSON.parse (JSON.stringify (valor)));
      });
    },
    copiarDatosRegistroADatosRegistroFormulario(datosRegistro) {
      for (const clave in this.datosRegistroFormulario)
        this.$delete (this.datosRegistroFormulario, clave);
      Object.entries (datosRegistro).forEach (([clave, valor]) => {
        if (valor !== undefined)
          this.$set (this.datosRegistroFormulario, clave, JSON.parse (JSON.stringify (valor)));
      });
    },
    actualizarRegistro (registro) {
      return new Promise ((resolve) => {
        if (this.modoMemoria) {
          resolve (registro);
          return;
        }

        this.cargandoRegistro = true;
        api.obtenerRegistrosTablaVista (
          this.tabla,
          { _cr: JSON.stringify (this.claveRegistro (registro)) } // parametro "_cr" = clave de registro serializado como JSON
        )
          .then ((respuesta) => {
            Object.entries (respuesta.data).forEach (([campo, valor]) => { registro [campo] = valor; });
            resolve (registro);
          })
          .finally (() => {
            this.cargandoRegistro = false;
          });
      });
    },

    //----------------- C R E A T E
    anadirRegistro (registro) {
      if (!registro) registro = {};
      this.copiarDefinicionCamposADefinicionCamposFormulario ();
      this.copiarDatosRegistroADatosRegistroFormulario (registro);
      this.formulario.mostrar (CONSTANTES_CRUD.ACCION.CREATE,
                                this.$t ('Añadir') + ' ' + this.tituloCrud,
                                this.definicionCamposFormulario,
                                this.datosRegistroFormulario,
                                null,
                                {
                                  antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                  antesGuardar: this.eventoAntesGuardarFormularioDatos,
                                  despuesGuardar: this.eventoDespuesGuardarFormularioDatos,
                                  antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                  botonAccion: this.accionInsertarRegistro,
                                });
    },
    async accionInsertarRegistro (formularioDatos, datosRegistro, copiaDatosRegistro, arrayCambiosEnRegistro) {
      try {
        if (this.modoMemoria) {
          arrayCambiosEnRegistro ['!!'] = CONSTANTES_CRUD.ACCION.CREATE;
          this.registros.push (arrayCambiosEnRegistro);
          this.totalRegistrosSinPaginar++;

          this.complementarDatos (this.registros);
          this.prepararCabeceras ();
        } else if (Object.entries (arrayCambiosEnRegistro).length > 0) {
          await api.anadirRegistroTablaVista (this.tabla, arrayCambiosEnRegistro, !this.eventoErrorApi)
                  .then ((respuesta) => {
                    datosRegistro [respuesta.data.campo_id] = respuesta.data.id_registro_insertado;
                  });
        }

        this.$emit ('cambios', this);
        return true;
      } catch (e) {
        if (this.eventoErrorApi)
          this.eventoErrorApi (e.response);
        return false;
      }
    },

    //----------------- U P D A T E
    editarRegistro (registro) {
      // antes de nada, refrescamos el registro a editar
      this.actualizarRegistro (registro)
        .then ((registro) => {
          this.copiarDefinicionCamposADefinicionCamposFormulario ();
          this.copiarDatosRegistroADatosRegistroFormulario (registro);
          this.formulario.mostrar (CONSTANTES_CRUD.ACCION.UPDATE,
                                    this.$t ('Editar') + ' ' + this.tituloCrud,
                                    this.definicionCamposFormulario,
                                    this.datosRegistroFormulario,
                                    this.campoSujetoAccion,
                                    {
                                      antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                      antesGuardar: this.eventoAntesGuardarFormularioDatos,
                                      despuesGuardar: this.eventoDespuesGuardarFormularioDatos,
                                      antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                      botonAccion: this.accionEditarRegistro,
                                    });
        })
    },
    async accionEditarRegistro (formularioDatos, datosRegistro, copiaDatosRegistro, arrayCambiosEnRegistro) {
      try {
        if (this.modoMemoria) {
          for (let i = 0; i < this.registros.length; i++) {
            if (JSON.stringify (this.registros [i]) == JSON.stringify (copiaDatosRegistro)) {
              if (copiaDatosRegistro ['!!'] != CONSTANTES_CRUD.ACCION.CREATE)
                this.$set (this.registros [i], '!!', CONSTANTES_CRUD.ACCION.UPDATE);
              for (const [campo, valor] of Object.entries (arrayCambiosEnRegistro))
                this.$set (this.registros [i], campo, valor);
              break;
            }
          }
          this.complementarDatos (this.registros);
        } else if (Object.entries (arrayCambiosEnRegistro).length > 0) {
          this.cargandoRegistro = true;
          try {
            await api.modificarRegistroTablaVista (this.tabla, arrayCambiosEnRegistro, this.claveRegistro (copiaDatosRegistro), !this.eventoErrorApi);
          } finally {
          this.cargandoRegistro = false;
          }
        }
        this.$emit ('cambios', this);
        return true;
      } catch (e) {
        if (this.eventoErrorApi)
          this.eventoErrorApi (e.response);
        return false;
      }
    },

    //----------------- D E L E T E
    eliminarRegistro (registro) {
      this.actualizarRegistro (registro)
        .then ((registro) => {
          this.copiarDefinicionCamposADefinicionCamposFormulario ();
          this.copiarDatosRegistroADatosRegistroFormulario (registro);
          this.formulario.mostrar (CONSTANTES_CRUD.ACCION.DELETE,
                                    this.$t ('Eliminar') + ' ' + this.tituloCrud,
                                    this.definicionCamposFormulario,
                                    this.datosRegistroFormulario,
                                    this.campoSujetoAccion,
                                    {
                                      antesAbrir: this.eventoAntesAbrirFormularioDatos,
                                      botonAccion: this.accionEliminarRegistro,
                                      antesCerrarFormulario: this.antesCerrarFormularioDatos,
                                    });
        });
    },
    async accionEliminarRegistro (formularioDatos, datosRegistro, copiaDatosRegistro) {
      try {
        if (this.modoMemoria) {
          for (let i = 0; i < this.registros.length; i++) {
            if (JSON.stringify (this.registros [i]) == JSON.stringify (copiaDatosRegistro)) {
              if (copiaDatosRegistro ['!!'] == CONSTANTES_CRUD.ACCION.CREATE)
                this.registros.splice (i, 1);
              else
                this.$set (this.registros [i], '!!', CONSTANTES_CRUD.ACCION.DELETE);
              this.totalRegistrosSinPaginar--;
              break;
            }
          }
          this.prepararCabeceras ();
        } else {
          if (this.mensajeConfirmacionAlEliminar) {
            let botonSeleccionado = await this.$cuadroDeDialogo.mostrarEx ({
                propsDialog: { width: "450px", maxWidth: "80%" },
                propsCard: { dark: true },
                titulo: {
                  texto: `Confirmar eliminar ${this.tituloCrud}`,
                  estilo: "background: #FF0000",
                  icono: {
                    nombre: "mdi-alert",
                    large: true
                  }
                },
                cuerpo: { mensajes: this.mensajeConfirmacionAlEliminar },
                acciones: {
                  botones: [
                    { identificador: 'DELETE', texto: this.$t ('Eliminar'), props: { text: true, color: "red" } },
                    { identificador: 'CANCEL', texto: this.$t ('Cancelar'), props: { text: true } }
                  ]
                }
            });
            if (botonSeleccionado.identificador != 'DELETE')
              return false;
          }
          await api.eliminarRegistroTablaVista (this.tabla, this.claveRegistro (copiaDatosRegistro), !this.eventoErrorApi);
        }
        this.$emit ('cambios', this);
        return true;
      } catch (e) {
        if (this.eventoErrorApi)
          this.eventoErrorApi (e.response);
        return false;
      }
    }
  },
  watch: {
    opcionesTabla() {
      this.actualizarDatos();
      this.$store.guardar_preferencia ('itemsPerPage', this.opcionesTabla.itemsPerPage, this.filasPorPagina, 'tablaDatosAPI', this.tabla);
    },
    valorZoom() {
      this.$store.guardar_preferencia ('zoom', this.valorZoom, this.zoom, 'tablaDatosAPI', this.tabla);
    },
    vistaCompacta() {
      this.$store.guardar_preferencia ('vistaCompacta', this.vistaCompacta, this.dense, 'tablaDatosAPI', this.tabla);
    },
    registrosSeleccionados() {
      this.$emit ("seleccionModificada", this.registrosSeleccionados);
    },
    ocultarRejilla() {
      [
        this.$el.getElementsByClassName('v-data-table__wrapper')[0],
        this.$el.getElementsByClassName('v-data-footer')[0]
      ].forEach ((e) => {
        e.style.visibility = this.ocultarRejilla ? "hidden" : "visible";
        e.style.maxHeight = this.ocultarRejilla ? 0 : "none";
      });
    }
  },
  created() {
    this.instanciaTablaDatosAPI = this;

    this.valorZoom = this.$store.leer_preferencia ('zoom', this.zoom, 'tablaDatosAPI', this.tabla);
    this.vistaCompacta = this.$store.leer_preferencia ('vistaCompacta', this.dense, 'tablaDatosAPI', this.tabla);
    this.opcionesTabla.itemsPerPage = this.$store.leer_preferencia ('itemsPerPage', this.filasPorPagina, 'tablaDatosAPI', this.tabla);

    // copiamos la prop "campos" en una variable interna reactiva:
    this.camposInterno = [...this.campos];

    // si se ha especificado un objeto de "definicionCampos" externo, lo utilizamos en lugar del objeto interno habitual
    if (this.objetoDefinicionCampos)
      this.definicionCamposFormulario = this.objetoDefinicionCampos;
    // si se ha especificado un objeto de "datosRegistro" externo, lo utilizamos en lugar del objeto interno habitual
    if (this.objetoRegistroFormulario) // sería "objetoDatosRegistro"
      this.datosRegistroFormulario = this.objetoRegistroFormulario;
  },
  beforeMount() {
    if (!this.modoMemoria)
      window.addEventListener ("focus", this.actualizarDatosSiFormularioNoVisible);

    if (this.segundosAutoRefresco > 0)
       this.idIntervalo = setInterval (this.actualizarDatosSiFormularioNoVisible, this.segundosAutoRefresco * 1000);
  },
  beforeDestroy() {
    if (!this.modoMemoria)
      window.removeEventListener ("focus", this.actualizarDatosSiFormularioNoVisible);

    if (this.idIntervalo)
      clearInterval (this.idIntervalo);
  },
  mounted() {
    this.formulario = this.$refs ['formulario'];
    this.$emit ("montado", this);
  }
};
</script>

<style scoped>
.v-data-table thead {
  background-color: #e4e4f4;
}
tr.v-data-table__selected {
  background:#b1bdf9 !important;
}
.cargando {
  z-index: 1001;
  position: fixed;
  left: 50vw;
  top: 48vh;
  margin: -40px 0px 0px -40px;
}
</style>